import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue, KeyValueDefault } from '@/main/models/common';

// Redux
import {
  saveInsurers,
  GetInsurers,
  saveInsurersPublic,
  GetInsurersPublic,
  GetInsurersFull,
  saveInsurersFull,
  GetUsersByInsurer,
  saveUsersByInsurer
} from '.';

// Api's
import { insurerApi } from '../../api';
import {
  errorBoundaryReduxSaga,
  renderErrorReduxSaga
} from '@/main/services/utils';

export function* getInsurersSaga(action: GetInsurers) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      insurerApi.getInsurersOrInsurerBranchesDomain,
      action.payload.request
    );
    if (response.data.result) {
      yield put(
        saveInsurers(
          response.data.result,
          false,
          null,
          action.payload.keyReducer
        )
      );
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(
        saveInsurers(
          null,
          true,
          resultError.messagesDataError,
          action.payload.keyReducer
        )
      );
    }
  }
}

export function* getInsurersPublicSaga(action: GetInsurersPublic) {
  try {
    const response: AxiosResponse<Result<KeyValueDefault[]>> = yield call(
      insurerApi.getInsurersPublic,
      action.payload.guidCountry
    );
    if (response.data.result) {
      yield put(
        saveInsurersPublic(
          response.data.result,
          false,
          null,
          action.payload.keyReducer
        )
      );
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(
        saveInsurersPublic(
          null,
          true,
          resultError.messagesDataError,
          action.payload.keyReducer
        )
      );
    }
  }
}

export function* getInsurersFullSaga(action: GetInsurersFull) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      insurerApi.getInsurersFullDomain,
      action.payload.request
    );
    if (response.data.result) {
      yield put(saveInsurersFull(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveInsurersFull(null, true, resultError.messagesDataError));
    }
  }
}

export function* getUsersByInsurerSaga(action: GetUsersByInsurer) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      insurerApi.getUsersByInsurer,
      action.payload.request
    );

    if (response.data.result) {
      yield put(saveUsersByInsurer(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveUsersByInsurer(null, true, resultError.messagesDataError));
    }
  }
}

